/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormElement } from '@progress/kendo-react-form';
import { Button, ButtonGroup, Container } from 'react-bootstrap';
import { mmurApi } from 'utility/axios_config';
import moment from 'moment';
import { SSN_EMPTY_MASK } from 'utility/constants';
import { toolsEndpoints } from 'endpoints/tools';
import { HsmvQueryFields } from './hsmv_query_fields';
import { HsmvDemoCheckValidatorFactory } from './hsmv_demo_check_validator';

// @ts-ignore
import styles from './tools.module.scss';
import { HsmvDemoResultModal } from './hsmv_demo_result_modal';

function HsmvDemoCheck(props) {
  const [showHsmvResultModal, setShowHsmvResultModal] = useState(false);
  const [hsmvResultData, setHsmvResultData] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalSubtitle, setModalSubitle] = useState('');

  const handleSubmit = async (options) => {
    const params = {
      ...options,
      ssn: options.ssn && options.ssn !== SSN_EMPTY_MASK ? options.ssn : ''
    };

    const url = toolsEndpoints.getHsmvDemoCheck(params);

    const title = 'Demographic Search Results';

    const subTitle = () => {
      let stringBuilder = 'Results of checking: ';
      if (params.ssn && params.ssn !== SSN_EMPTY_MASK) {
        stringBuilder += `SSN: ${params.ssn} `;
        if (params.driversLicenseNumber) {
          stringBuilder += 'and ';
        }
      }
      if (params.driversLicenseNumber) {
        stringBuilder += `DL: ${params.driversLicenseNumber} `;
      }
      const [dob] = params.dob.split('-');
      return `${stringBuilder}and DOB: ${dob} as of ${moment().format('MM/DD/YYYY hh:mm A')}`;
    };

    setModalTitle(title);
    setModalSubitle(subTitle);

    mmurApi.get(url).then(({ data: { data } }) => {
      // eslint-disable-next-line max-len
      setHsmvResultData(JSON.stringify(data.jsonResponse, null, 2));
      setShowHsmvResultModal(true);
    });
  };

  return (
    <Container className="text-center">
      <div>
        <h3>API Tools - HSMV Demographics</h3>
      </div>
      <div>
        <Form
          onSubmit={handleSubmit}
          validator={HsmvDemoCheckValidatorFactory()}
          render={(formRenderProps) => (
            <FormElement>
              <HsmvQueryFields
                formRenderProps={formRenderProps}
                categoryClientContent={props.categoryClientContent}
              />
              <div className={styles.hsmvToolButtons}>
                <ButtonGroup>
                  <Button
                    className={styles.hsmvToolButton}
                    type="submit"
                    disabled={
                      !formRenderProps.allowSubmit || !formRenderProps.valid
                    }
                    variant="primary"
                  >
                    Submit
                  </Button>
                </ButtonGroup>
              </div>
            </FormElement>
          )}
        />
        <HsmvDemoResultModal
          show={showHsmvResultModal}
          heading={modalTitle}
          subTitle={modalSubtitle}
          data={hsmvResultData}
          buttontext="Close"
          size="xl"
          onHide={() => setShowHsmvResultModal(false)}
          centered
          static="static"
          animation={false}
        />
      </div>
    </Container>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state.content.categoryClientContent,
  };
}
export default connect(mapStateToProps)(HsmvDemoCheck);
